export default __webpack_public_path__ + "static/media/model-y.dc5ae8b7.png";